module.exports = __webpack_public_path__ + "static/media/organization-icon.0995bf18.svg";